import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import Icon from "../../common/icon/icon.component.jsx"
import {FormattedMessage} from "react-intl";

class BillingMethodSelector extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function(){},
            methods: {
                "one-time": true,
                "monthly": false,
                "yearly": false,
            }
        }
    }

    setMethods(methods) {
        const newMethods = {
            "one-time": false,
            "monthly": false,
            "yearly": false,
        }
        for (let index in methods) {
            newMethods[methods[index]] = true
        }
        this.setState({
            methods: newMethods
        })
    }

    getMethods() {
        const methods = []
        for (let index in this.state.methods) {
            if (this.state.methods[index]) {
                methods.push(index)
            }
        }
        return methods
    }

    componentDidMount() {
        this.setMethods(this.props.value || [])
    }

    componentWillReceiveProps(nextProps) {
        this.setMethods(nextProps.value || [])
    }

    getBillingMethods() {
        return [
            {
                id: 'one-time',
                icon: <Icon value={"circle"} />,
                name: <FormattedMessage
                    id="product.billing_method.one_time.name"
                    defaultMessage="One time"
                />,
            },
            {
                id: 'monthly',
                icon: <Icon value={"calendar-alt"} />,
                name: <FormattedMessage
                    id="product.billing_method.monthly.name"
                    defaultMessage="Monthly"
                />,
            },
            {
                id: 'yearly',
                icon: <Icon value={"calendar-alt"} />,
                name: <FormattedMessage
                    id="product.billing_method.yearly.name"
                    defaultMessage="Yearly"
                />,
            },
        ]
    }

    selectMethod(id) {
        return function (e) {
            e.preventDefault()
            const currentMethods = this.state.methods
            currentMethods[id] = !currentMethods[id]
            this.setState({
                methods: currentMethods,
            }, () => {
                this.state.onChange(this.getMethods())
            })
        }.bind(this)
    }

    render() {
        const error = this.getMethods().length === 0
        return (
            <div className="row">
                <div className="col-12">
                    <div className="d-flex align-content-stretch flex-wrap">
                        {this.getBillingMethods().map(c => {
                            let className = "card h-100"
                            if (this.state.methods[c.id]) {
                                className += " bg-primary text-white"
                            }
                            if (error) {
                                className += " border-danger"
                            }
                            return <div key={c.id} className="col-xl-2 col-lg-3 align-self-stretch p-1 no-underline">
                                <a key={c.id} href='#' onClick={this.selectMethod(c.id)}>
                                    <div className={className}>
                                        <div className="card-body px-1">
                                            <h5 className="card-title m-0 p-0 border-0">
                                                <p className="text-center m-0">
                                                    {c.icon}
                                                </p>
                                            </h5>
                                            <h6 className="card-title m-0 p-0 border-0">
                                                <p className="text-center m-0 pt-1">
                                                    {c.name}
                                                </p>
                                            </h6>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        })}
                    </div>
                </div>
                {error ? <div className="col-12">
                    <p className={"text-danger"}>
                        <Icon value={"exclamation"}/>
                        <FormattedMessage
                            id="product.billing_method.required_error_message"
                            defaultMessage="At least one billing method have to be selected"
                        />
                    </p>
                </div> : ''}
            </div>
        );
    }
}

export default BillingMethodSelector


// WEBPACK FOOTER //
// ./src/product/billing-method/select.component.jsx